// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__Yu7V1","link":"not-found_link__TL0pv"};